import { render, staticRenderFns } from "./MarketData.vue?vue&type=template&id=54222c37"
import script from "./MarketData.vue?vue&type=script&lang=js"
export * from "./MarketData.vue?vue&type=script&lang=js"
import style0 from "./MarketData.vue?vue&type=style&index=0&id=54222c37&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports